export default __webpack_public_path__ + "static/media/generic-tail.9b92775f.png";